import PNotify from 'pnotify/dist/es/PNotify.js'
import PNotifyButtons from 'pnotify/dist/es/PNotifyButtons.js'
import PNotifyStyleMaterial from 'pnotify/dist/es/PNotifyStyleMaterial.js'

// Set default styling.
PNotify.defaults.styling = 'material'

// This icon setting requires the Material Icons font. (See below.)
PNotify.defaults.icons = 'material'

window.PNotify = PNotify

// PNotify.alert({
//     text: "I'm an alert.",
//     type: 'success',
// })
